import React from 'react'

// eslint-disable-next-line react/display-name
export default () => (
  <svg
    width='65px'
    height='65px'
    viewBox='0 0 65 65'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <defs>
      <filter x='-50%' y='-50%' width='200%' height='200%' filterUnits='objectBoundingBox' id='filter-1'>
        <feOffset dx='1' dy='1' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feColorMatrix
          values='0 0 0 0 0.031372549   0 0 0 0 0.325490196   0 0 0 0 0.592156863  0 0 0 1 0'
          type='matrix'
          in='shadowOffsetOuter1'
          result='shadowMatrixOuter1'
        />
        <feMerge>
          <feMergeNode in='shadowMatrixOuter1' />
          <feMergeNode in='SourceGraphic' />
        </feMerge>
      </filter>
    </defs>
    <g id='Flights_SOPQ' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='ExD-Tutorial-Overlay' transform='translate(-642.000000, -276.000000)'>
        <g id='320px-ExD-tutorial' transform='translate(423.000000, 197.000000)'>
          <g id='blue-icons' transform='translate(15.000000, 77.000000)'>
            <g id='ticket-blue' transform='translate(204.000000, 2.000000)'>
              <path
                d='M32.0779221,65 C49.7940692,65 64.1558442,50.4492544 64.1558442,32.5 C64.1558442,14.5507456 49.7940692,0 32.0779221,0 C14.3617749,0 0,14.5507456 0,32.5 C0,50.4492544 14.3617749,65 32.0779221,65 Z'
                id='Oval'
                fill='#fa0'
              />
              <g id='air-ticket-negotiated-copy-2' transform='translate(1.532468, 8.552632)'>
                <g id='Group' transform='translate(30.730576, 0.000000)'>
                  <path
                    d='M0.825576338,6.12440191 L10.2165072,6.12440191 C10.2165072,6.12440191 8.51375598,1.07177033 6.44981514,1.02073365 C4.38587429,0.96969697 2.11553936,1.53110048 0.825576338,6.12440191 L0.825576338,6.12440191 Z'
                    id='Shape'
                    fill='#FFFFFF'
                  />
                  <path
                    d='M10.990485,6.63476874 L0.206394084,6.63476874 L0.361189648,5.97129187 C1.75434972,1.02073365 4.38587429,0.408293461 6.50141366,0.510366826 C8.87494563,0.561403509 10.5776968,5.40988836 10.7840909,5.97129187 L10.990485,6.63476874 L10.990485,6.63476874 Z M1.54795563,5.61403509 L9.5457264,5.61403509 C8.82334711,3.72567783 7.53338408,1.53110048 6.50141366,1.53110048 C4.59226838,1.4800638 2.73472162,1.93939394 1.54795563,5.61403509 L1.54795563,5.61403509 Z'
                    id='Shape'
                    fill='#049'
                  />
                </g>
                <g id='Group' transform='translate(0.000000, 3.567916)'>
                  <path
                    d='M2.99248626,28.8794524 C2.17917757,28.8794524 1.46753247,28.197899 1.46753247,27.3066369 L1.46753247,3.45226795 C1.46753247,2.613433 2.17917757,1.87945242 2.99248626,1.87945242 L54.9425787,1.87945242 C55.8067192,1.87945242 56.4675325,2.613433 56.4675325,3.45226795 L56.4675325,27.3066369 C56.4675325,28.1454718 55.7558874,28.8794524 54.9425787,28.8794524 L2.99248626,28.8794524 Z'
                    id='Shape'
                    fill='#FFFFFF'
                  />
                  <path
                    d='M55.398567,28.8794524 L2.53649798,28.8794524 C1.39856695,28.8794524 0.467532468,27.9373963 0.467532468,26.7859945 L0.467532468,2.97291036 C0.467532468,1.82150849 1.39856695,0.879452419 2.53649798,0.879452419 L55.398567,0.879452419 C56.536498,0.879452419 57.4675325,1.82150849 57.4675325,2.97291036 L57.4675325,26.7859945 C57.4675325,27.9373963 56.536498,28.8794524 55.398567,28.8794524 L55.398567,28.8794524 Z M2.53649798,1.87384494 C1.96753247,1.87384494 1.50201523,2.34487298 1.50201523,2.92057391 L1.50201523,26.733658 C1.50201523,27.309359 1.96753247,27.780387 2.53649798,27.780387 L55.398567,27.780387 C55.9675325,27.780387 56.4330497,27.309359 56.4330497,26.733658 L56.4330497,2.92057391 C56.4330497,2.34487298 55.9675325,1.87384494 55.398567,1.87384494 L2.53649798,1.87384494 L2.53649798,1.87384494 Z'
                    id='Shape'
                    fill='#049'
                  />
                </g>
                <path
                  d='M13.4675325,31.4473684 L1.94330339,31.4473684 C1.67898621,31.4473684 1.46753247,31.237691 1.46753247,30.9755942 L1.46753247,6.49575552 C1.46753247,5.91914261 1.94330339,5.44736842 2.52480119,5.44736842 L13.4675325,5.44736842'
                  id='Shape'
                  fill='#0068ef'
                />
                <g id='Group' filter='url(#filter-1)' transform='translate(24.243905, 23.774588)'>
                  <path
                    d='M32.8016549,7.50441074 C31.7270297,8.60645708 25.9956953,8.44902189 25.9956953,8.44902189 C25.9956953,8.44902189 21.3901587,6.5597996 18.5756642,9.39363303 C14.8400623,7.97671632 10.5927341,6.19245082 7.57354902,8.86884906 C5.32195337,7.87175952 1.94455988,7.55688914 0.869934685,9.39363303 C0.869934685,9.39363303 0.409381028,9.55106822 0.869934685,10.4956794 C1.33048834,11.4402905 2.55863143,14.3266023 2.55863143,14.3266023 C2.55863143,14.3266023 0.869934685,15.1137783 1.02345257,15.9534326 C1.17697046,16.793087 2.8656672,22.9330594 2.8656672,22.9330594 C2.8656672,22.9330594 3.07035771,24.1925409 4.2985008,25.3470657 C5.52664388,26.5015904 9.05755525,29.492859 9.05755525,29.492859 C9.05755525,29.492859 10.7974246,30.8048189 12.2302582,29.492859 C13.6630918,28.1808991 14.7888896,26.2916768 14.7888896,26.2916768 C14.7888896,26.2916768 16.3752411,27.0788528 17.501039,26.1342416 C18.6268368,25.1896305 22.0042303,20.9913587 22.0042303,20.9913587 C22.0042303,20.9913587 25.0234154,23.6152786 27.2238384,22.7231458 C29.4242614,21.8310131 31.4199939,18.8922229 31.5735118,15.7959974 C31.5735118,15.7959974 34.2344885,15.4286487 35.3602863,14.3266023 C36.4860841,13.224556 38.2259535,10.705593 37.4071915,8.34406509 C36.5884294,5.98253724 33.0063454,0.314870381 33.0063454,0.314870381 C33.0063454,0.314870381 33.8251075,6.40236441 32.8016549,7.50441074 Z'
                    id='Shape'
                    fill='#FFFFFF'
                  />
                  <path
                    d='M10.746252,30.5424269 C9.92748994,30.5424269 9.15990051,30.1750782 8.75051948,29.8602078 C8.59700159,29.7027726 5.11726285,26.8689392 3.9402924,25.7144144 C2.60980406,24.4549329 2.35394091,23.0904946 2.35394091,23.0380162 C2.30276828,22.8281026 0.665244171,16.8980438 0.511726285,16.005911 C0.3582084,15.1137783 1.27931571,14.3790807 1.89338726,14.0642103 C1.53517886,13.224556 0.767589428,11.3878121 0.409381028,10.705593 C0.153517886,10.180809 0.102345257,9.70850341 0.204690514,9.34115463 C0.255863143,9.18371944 0.3582084,9.07876265 0.460553657,8.97380586 C1.63752411,7.08458357 4.86139971,7.13706197 7.42003114,8.1866299 C10.5415615,5.77262365 14.5841991,7.29449716 18.1662831,8.65893547 L18.3709736,8.76389227 C21.1854682,6.24492922 25.3304511,7.66184593 26.0468679,7.92423792 C28.3496362,7.97671632 31.7782023,7.76680273 32.3922739,7.13706197 C32.9551728,6.5597996 32.8528275,3.20118221 32.4946191,0.367348778 L33.4157264,0 C33.5692443,0.209913587 37.0489831,5.66766686 37.8677451,8.08167311 C38.7376798,10.5481578 37.2025009,13.1720776 35.6673221,14.6414727 C34.6950422,15.5860839 32.8528275,16.005911 31.9828928,16.1633462 C31.6758571,19.1546148 29.7312972,22.0934051 27.3773563,23.142973 C25.4327964,23.9826273 22.9765102,22.4082754 22.0042303,21.6735779 C21.1342956,22.7756242 18.729182,25.7144144 17.7569021,26.5015904 C16.7846222,27.2887663 15.5564791,27.0788528 14.8912349,26.8689392 C14.4818539,27.4986799 13.5607466,28.8106399 12.4349487,29.8077294 C11.9743951,30.3849918 11.3091509,30.5424269 10.746252,30.5424269 L10.746252,30.5424269 Z M1.12579783,9.70850341 C1.12579783,9.70850341 1.12579783,9.8659386 1.27931571,10.180809 C1.73986937,11.1254201 2.91683983,13.9067752 2.96801246,14.0117319 L2.71214931,14.6939511 C2.04690514,15.0088215 1.4328336,15.5336055 1.48400623,15.743519 C1.58635148,16.4257382 2.71214931,20.5715316 3.27504823,22.7231458 C3.27504823,22.7756242 3.53091137,23.8776706 4.55436394,24.8747601 C5.7313344,26.0292848 9.26224577,28.968075 9.31341839,28.968075 C9.36459102,29.0205534 10.746252,30.017643 11.8208772,28.968075 C13.2025382,27.7085935 14.2771634,25.924328 14.328336,25.8718496 L14.9935802,25.661936 C14.9935802,25.661936 16.3240685,26.2916768 17.1940032,25.5569792 C18.2686284,24.6648465 21.5436766,20.5190532 21.5948492,20.5190532 L22.311266,20.4665748 C23.0788555,21.1487939 25.483969,22.7756242 27.0191479,22.0934051 C29.1683983,21.2012723 30.9082676,18.4199173 31.0106129,15.6385623 L31.4711666,15.1662567 C32.1875834,15.0612999 34.1321432,14.6414727 35.0020779,13.8542968 C36.0767031,12.8047288 37.6630546,10.5481578 36.9466378,8.39654349 C36.4349115,6.92714838 34.8997327,4.25075014 33.7739348,2.41400625 C33.9274527,4.46066373 33.9274527,6.97962678 33.1598633,7.81928113 C31.9828928,9.02628425 26.9679752,8.92132746 25.9445227,8.92132746 L25.7910048,8.86884906 C25.7398322,8.86884906 21.4413314,7.13706197 18.8826999,9.70850341 L18.3709736,9.8134602 L17.8592474,9.60354662 C14.2771634,8.2391083 10.5415615,6.82219159 7.8805848,9.18371944 L7.36885851,9.28867624 C5.11726285,8.2915867 2.20042303,8.13415151 1.33048834,9.60354662 L1.12579783,9.70850341 L1.12579783,9.70850341 Z'
                    id='Shape'
                    fill='#049'
                  />
                </g>
                <path
                  d='M55.2888688,40.3615098 C52.7281966,40.3615098 42.9464289,36.9790787 42.2294407,36.6091253 C40.9491046,35.9749195 41.8197331,33.6494981 41.9733734,33.1738437 L42.8952154,33.5966476 C42.5367213,34.4951059 42.4342944,35.5521156 42.6391482,35.6578166 C43.765844,36.2391719 54.0597462,39.621603 55.3912957,39.3045001 L55.5961495,40.3615098 L55.2888688,40.3615098 L55.2888688,40.3615098 Z'
                  id='Shape'
                  fill='#049'
                />
                <path
                  d='M45.8893197,45.3375864 C43.4576389,43.9475083 31.2992348,36.9456336 30.5231665,35.761493 C29.5401466,34.2684462 31.0405454,32.6724307 31.0922833,32.6209463 L31.8683516,33.3417275 C31.8683516,33.3417275 30.8335938,34.4228994 31.4027106,35.2466493 C32.0235653,36.0703993 40.9224823,41.3218053 46.4066986,44.4623521 L45.8893197,45.3375864 L45.8893197,45.3375864 Z'
                  id='Shape'
                  fill='#049'
                />
                <path
                  d='M38.7689612,50.8665603 C38.4637061,50.6554958 31.4937142,45.4844139 30.1709421,44.2707927 C28.8481699,43.0044053 26.5078807,38.8886462 26.406129,38.6775817 L27.2710185,38.1499203 C27.2710185,38.2026864 29.6621835,42.3184454 30.883204,43.4793005 C32.1042245,44.6929218 39.2777197,49.9695359 39.3794714,50.0223021 L38.7689612,50.8665603 L38.7689612,50.8665603 Z'
                  id='Shape'
                  fill='#049'
                />
                <g id='Group' transform='translate(16.467532, 7.447368)' fill='#0068ef'>
                  <polygon
                    id='Shape'
                    points='0.0511336696 0.452370596 2.65895082 0.452370596 2.65895082 1.40737519 1.12494073 1.40737519 1.12494073 2.36237978 2.55668348 2.36237978 2.55668348 3.26712097 1.12494073 3.26712097 1.12494073 5.07660335 0.0511336696 5.07660335'
                  />
                  <polygon
                    id='Shape'
                    points='3.17028751 0.452370596 4.24409457 0.452370596 4.24409457 4.12159876 5.77810466 4.12159876 5.77810466 5.07660335 3.17028751 5.07660335'
                  />
                  <polygon
                    id='Shape'
                    points='6.03377301 0.452370596 7.15871374 0.452370596 7.15871374 5.07660335 6.03377301 5.07660335'
                  />
                  <path
                    d='M9.86879822,4.72475956 C9.76653088,4.87554976 9.66426355,4.97607656 9.51086254,5.02633995 C9.4085952,5.07660335 9.25519419,5.12686675 9.10179318,5.12686675 C8.84612483,5.12686675 8.59045649,5.02633995 8.33478814,4.82528636 C8.07911979,4.62423276 7.92571878,4.32265236 7.82345144,3.97080856 C7.7211841,3.56870137 7.67005043,3.21685757 7.67005043,2.76448698 C7.67005043,2.06079938 7.82345144,1.45763859 8.13025346,1.05553139 C8.43705548,0.603160795 8.8972585,0.402107196 9.45972887,0.402107196 C9.81766455,0.402107196 10.1756002,0.502633995 10.4312686,0.653424194 L10.4312686,1.65869219 C10.1756002,1.40737519 9.91993189,1.30684839 9.66426355,1.30684839 C9.35746153,1.30684839 9.15292685,1.45763859 8.99952584,1.70895558 C8.84612483,1.96027258 8.79499116,2.36237978 8.79499116,2.81475037 C8.79499116,3.26712097 8.84612483,3.56870137 8.94839217,3.82001837 C9.05065951,4.07133536 9.20406052,4.22212556 9.35746153,4.22212556 C9.45972887,4.22212556 9.51086254,4.17186216 9.56199621,4.07133536 C9.61312988,3.97080856 9.61312988,3.87028177 9.61312988,3.66922817 L9.61312988,3.36764777 L9.25519419,3.36764777 L9.25519419,2.51316998 L10.6358033,2.51316998 L10.6358033,4.97607656 L10.1244666,4.97607656 L9.86879822,4.72475956 L9.86879822,4.72475956 Z'
                    id='Shape'
                  />
                  <polygon
                    id='Shape'
                    points='11.300541 0.452370596 12.374348 0.452370596 12.374348 2.26185298 13.2436204 2.26185298 13.2436204 0.452370596 14.3174275 0.452370596 14.3174275 5.07660335 13.2436204 5.07660335 13.2436204 3.16659417 12.374348 3.16659417 12.374348 5.07660335 11.300541 5.07660335'
                  />
                  <polygon
                    id='Shape'
                    points='14.8287642 0.452370596 17.794517 0.452370596 17.794517 1.40737519 16.874111 1.40737519 16.874111 5.07660335 15.8003039 5.07660335 15.8003039 1.40737519 14.8287642 1.40737519'
                  />
                  <polygon
                    id='Shape'
                    points='19.8909975 0.452370596 22.8567503 0.452370596 22.8567503 1.40737519 21.8852106 1.40737519 21.8852106 5.07660335 20.8114035 5.07660335 20.8114035 1.40737519 19.8909975 1.40737519'
                  />
                  <polygon
                    id='Shape'
                    points='23.368087 0.452370596 24.4930277 0.452370596 24.4930277 5.07660335 23.368087 5.07660335'
                  />
                  <path
                    d='M27.5610479,4.97607656 C27.3053795,5.12686675 27.0497112,5.17713015 26.7940428,5.17713015 C26.2827062,5.17713015 25.8225031,4.97607656 25.5157011,4.47344256 C25.2088991,4.02107196 25.0554981,3.46817457 25.0554981,2.76448698 C25.0554981,2.36237978 25.1066318,1.96027258 25.2600328,1.60842879 C25.4134338,1.25658499 25.6179684,0.955004591 25.8736368,0.703687594 C26.1293051,0.502633995 26.4872408,0.351843797 26.8451765,0.351843797 C27.0497112,0.351843797 27.3053795,0.402107196 27.5610479,0.502633995 L27.5610479,1.55816539 C27.4076469,1.40737519 27.2031122,1.30684839 26.9985775,1.30684839 C26.7429092,1.30684839 26.5383745,1.45763859 26.3849735,1.70895558 C26.2315725,1.96027258 26.1804388,2.31211638 26.1804388,2.81475037 C26.1804388,3.21685757 26.2315725,3.56870137 26.3849735,3.82001837 C26.5383745,4.07133536 26.7429092,4.17186216 26.9474439,4.17186216 C27.1008449,4.17186216 27.3053795,4.07133536 27.5610479,3.92054516 L27.5610479,4.97607656 L27.5610479,4.97607656 Z'
                    id='Shape'
                  />
                  <polygon
                    id='Shape'
                    points='28.0723846 0.452370596 29.1461916 0.452370596 29.1461916 2.11106278 29.9643304 0.452370596 31.0381374 0.452370596 30.1177314 2.01053598 31.1915384 5.07660335 29.9643304 5.07660335 29.4529937 3.21685757 29.1461916 3.71949157 29.1461916 5.02633995 28.0723846 5.02633995 28.0723846 0.452370596'
                  />
                  <polygon
                    id='Shape'
                    points='31.4472068 0.452370596 34.1061576 0.452370596 34.1061576 1.40737519 32.5210138 1.40737519 32.5210138 2.26185298 34.0038903 2.26185298 34.0038903 3.16659417 32.5210138 3.16659417 32.5210138 4.17186216 34.1061576 4.17186216 34.1061576 5.12686675 31.4472068 5.12686675'
                  />
                  <polygon
                    id='Shape'
                    points='34.4640933 0.452370596 37.4298461 0.452370596 37.4298461 1.40737519 36.4583064 1.40737519 36.4583064 5.07660335 35.3844993 5.07660335 35.3844993 1.40737519 34.4640933 1.40737519'
                  />
                </g>
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='33.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='35.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='37.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='39.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='41.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='43.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='45.4675325'
                  y='16.4473684'
                  width='1.08111187'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='47.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='49.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='51.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
                <rect
                  id='Rectangle-path'
                  fill='#0068ef'
                  x='53.4675325'
                  y='16.4473684'
                  width='1'
                  height='11'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
